































import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import EventBus from "@/EventBus";

@Component({
    components: {},
    computed: {
        ...mapGetters({user: 'user', isCompany: 'isCompany', isWorker: 'isWorker'})
    },
    name: "NavBar"
})
export default class NavBar extends Vue {
    @Prop(Boolean) private readonly value!:boolean;
    private colored:boolean = false;

    created(){
        EventBus.$on('nav:colored',(b:boolean)=>{
            this.colored = b;
        })
    }

    get show(){
        return this.value
    }

    set show(val:boolean){
        this.$emit('input',val)
    }
}
